export default function UrlUtilService() {
  function appendDefaultProtocol(hyperlink) {
    if (hyperlink.indexOf('://') === -1) {
      return 'https://' + hyperlink;
    }
    return hyperlink;
  }

  function toRangeParam(start, end) {
    var startDateFormat = start.toISOString();
    var endDateFormat = end.toISOString();

    return startDateFormat + '/' + endDateFormat;
  }

  return {
    appendDefaultProtocol: appendDefaultProtocol,
    toRangeParam: toRangeParam,
  };
}
